export default function ContactMap(){
    return (
        <div className="contact-maps col-md-6 float-left wow fadeInRight">
          <div className="maps">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.1393426070426!2d72.89321387500534!3d21.22632238096419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04fe95123bd15%3A0xe4c93641b1fe3664!2sSRP%20Infotech!5e0!3m2!1sen!2sin!4v1694250584333!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy"/>
          </div>
        </div>
    )
}